import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogTransition from './Transition'
import PropTypes from 'prop-types'

class DialogAlert extends React.Component {

    render() {
        return (
            <Dialog
                open={this.props.isDialogOpen}
                TransitionComponent={DialogTransition}
                keepMounted
                onClose={() => this.props.onClose()}
                aria-labelledby="DialogTitle"
            >
                <DialogTitle id="DialogTitle">
                    <div className="title-label">
                        {this.props.message}
                    </div>
                    <IconButton className="close-button" onClick={() => this.props.onClose()} aria-label="Close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
            </Dialog>
        )
    }
}

DialogAlert.propTypes = {
    isDialogOpen: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default DialogAlert